import Certificate1 from "../../assets/certificate/certificate_1.jpg"
import Certificate2 from "../../assets/certificate/certificate_2.jpg"
import Certificate3 from "../../assets/certificate/certificate_3.jpg"
import Certificate4 from "../../assets/certificate/certificate_4.jpg"
import Certificate5 from "../../assets/certificate/certificate_5.jpg"
import Certificate6 from "../../assets/certificate/certificate_6.jpg"
import Certificate7 from "../../assets/certificate/certificate_7.jpg"
import Certificate8 from "../../assets/certificate/certificate_8.jpg"
import Certificate9 from "../../assets/certificate/certificate_9.jpg"
const CertificateData = [
    {
      id: 1,
      image: Certificate1,
      title: "Complete React Developer in 2022",
      category: "Udemy",
      demo: "https://www.udemy.com/certificate/UC-195f2519-e0db-4471-9e52-0f23863c2d62/?utm_source=sendgrid.com&utm_medium=email&utm_campaign=email"
    },
    {
      id: 2,  
      image: Certificate2,
      title: "Bachelors Convocation Certificate",
      category: "Mumbai University",
      demo: "#"
    },
    {
      id: 3,
      image: Certificate3,
      title: "I-Senso Robotics",
      category: "Work Shop",
      demo: "#"
    },
    {
      id: 4,
      image: Certificate4,
      title: "HTML Fundamental Course",
      category: "Solo Learn",
      demo: "#"
    },
    {
      id: 5,
      image: Certificate5,
      title: "CSS Fundamental Course ",
      category: "Solo Learn",
      demo: ""
    },  
    {
      id: 6,
      image: Certificate6,
      title: "JAVA Fundamental Course",
      category: "Solo Learn",
      demo: "#"
    },  
    {
      id: 7,
      image: Certificate7,
      title: "ISRO",
      category: "Other",
      demo: ""
    },
    {
      id: 8,
      image: Certificate9,
      title: "Big Data Computing",
      category: "NPTEL",
      demo: ""
    },
    {
      id: 9,
      image: Certificate8,
      title: "JEE Main Paper 2 2017",
      category: "Other",
      demo: "#"
    },
    
  ];
  

export default CertificateData